/**
 * Webmail self-service quarantine (services/platform-api modules/quarantine/me-routes.ts): the user's own held items
 * in the zones the access profile allows. Spread into the webmail client.
 */
import type { HttpClient } from './http';
import type { QueryParams, SuccessBody } from './types';

export type MyQuarantine = SuccessBody<'/api/v1/me/quarantine', 'get'>;
export type MyQuarantineItem = MyQuarantine['items'][number];
export type MyQuarantineQuery = QueryParams<'/api/v1/me/quarantine', 'get'>;
export type MyQuarantinePermission = SuccessBody<'/api/v1/me/quarantine/permission', 'get'>;
export type MyQuarantinePreview = SuccessBody<'/api/v1/me/quarantine/{id}/preview', 'get'>;
export type MyQuarantineHistory = SuccessBody<'/api/v1/me/quarantine/{id}/history', 'get'>;

export function createQuarantineMeClient(http: HttpClient) {
  return {
    myQuarantinePermission: () => http.request('get', '/api/v1/me/quarantine/permission'),
    myQuarantine: (query: MyQuarantineQuery = {}) => http.request('get', '/api/v1/me/quarantine', { query }),
    previewMyQuarantine: (id: string) => http.request('get', '/api/v1/me/quarantine/{id}/preview', { path: { id } }),
    myQuarantineHistory: (id: string, cursor?: string, recipientId?: string) => http.request('get', '/api/v1/me/quarantine/{id}/history', { path: { id }, query: { ...(cursor === undefined ? {} : { cursor }), ...(recipientId === undefined ? {} : { recipientId }) } }),
    /** Both authorized options bypass scans/rules; attachments default to a new attachment-only mail. */
    releaseMyQuarantine: (id: string, comment?: string, option?: 'original' | 'attachment', recipientId?: string) => http.request('post', '/api/v1/me/quarantine/{id}/release', { path: { id }, body: { comment, option, recipientId } }),
    deleteMyQuarantine: (id: string, comment?: string, recipientId?: string) => http.request('post', '/api/v1/me/quarantine/{id}/delete', { path: { id }, body: { comment, recipientId } }),
    requestMyQuarantineRelease: (id: string, comment?: string, recipientId?: string) => http.request('post', '/api/v1/me/quarantine/{id}/request-release', { path: { id }, body: { comment, recipientId } }),
  };
}
